module.exports = __webpack_public_path__ + "static/media/start-reading.19b8ffda.png";